/**
 * Shared animation configuration for all bottom sheets
 * Optimized to prevent jitter and provide smooth animations
 */

export const SHEET_ANIMATION = {
  initial: { y: '100%' },
  animate: { y: 0 },
  exit: { y: '100%' },
  transition: {
    type: 'spring',
    damping: 35,      // Increased from 25-30 for less oscillation
    stiffness: 200,   // Reduced from 300 for smoother motion
    mass: 0.8,        // Added mass for more natural movement
    velocity: 0       // Start from rest to prevent initial jitter
  }
};

export const BACKDROP_ANIMATION = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: {
    duration: 0.2,    // Fast fade for backdrop
    ease: 'easeOut'
  }
};

// Alternative smoother animation using tween instead of spring
export const SHEET_ANIMATION_SMOOTH = {
  initial: { y: '100%' },
  animate: { y: 0 },
  exit: { y: '100%' },
  transition: {
    type: 'tween',
    duration: 0.3,
    ease: [0.32, 0.72, 0, 1]  // Custom ease curve for smooth motion
  }
};

export default SHEET_ANIMATION;